module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.company && _vm.freight && _vm.freight.id) ? _c('div', {
    staticClass: "print stock-note"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('span', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s('ИНН: ' + _vm.company.inn))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s('КПП: ' + _vm.company.kpp))])]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [(_vm.companyAddress && _vm.companyAddress.id) ? _c('span', [_vm._v(_vm._s(_vm.companyAddress.address))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.company && _vm.company.phone) ? _c('span', [_vm._v(_vm._s('тел.: ' + _vm.company.phone))]) : _vm._e()])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    }
  }, [(_vm.freight.traking_number) ? _c('h1', [_vm._v(_vm._s('Складская записка № ' + _vm.freight.traking_number))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Данные отправления")]), _vm._v(" "), (_vm.acceptedTracking && _vm.acceptedTracking.date) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Дата приёма груза:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.moment(_vm.acceptedTracking.date).format('DD.MM.YYYY')))])]) : _vm._e(), _vm._v(" "), (_vm.fromStock && _vm.fromStock.city) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Адрес сдачи груза:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.fromStock.city.name + ', ' + _vm.fromStock.name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Данные назначения")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Пункт назначения:")]), _vm._v(" "), (_vm.toCity && _vm.toCity.name) ? _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.toCity.name))]) : _vm._e()])]), _vm._v(" "), (_vm.freight && _vm.freight.id) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Характеристики груза")]), _vm._v(" "), (_vm.freight.description) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Наименование груза:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.freight.description))])]) : _vm._e(), _vm._v(" "), (_vm.freight.seats_number) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Количество мест:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.freight.seats_number))])]) : _vm._e(), _vm._v(" "), (_vm.freight.weight) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Вес:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.freight.weight + ' кг'))])]) : _vm._e(), _vm._v(" "), (_vm.freight.size && _vm.freight.size_units) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Объем:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.freight.size + ' ' + _vm.freight.size_units + '3'))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.freight && _vm.freight.id) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Дополнительные услуги")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Требуется обрещётка:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s((parseInt(_vm.freight.doom) === 1) ? 'Да' : 'Нет'))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Заводская упаковка:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s((parseInt(_vm.freight.factory_package) === 1) ? 'Да' : 'Нет'))])]), _vm._v(" "), (_vm.freight.services && _vm.freight.services.length) ? _c('div', _vm._l((_vm.freight.services), function(service) {
    return _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "col-1"
    }, [_vm._v("\n                            " + _vm._s((service.service.type == 'radio' || service.service.type == 'select') ? service.service.name : service.name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("\n                            " + _vm._s((service.service.type == 'radio' || service.service.type == 'select') ? service.name : 'Да') + "\n                        ")])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Подпись клиента")]), _vm._v(" "), (_vm.deal && _vm.deal.from_signature) ? _c('div', {
    staticClass: "sign"
  }, [_c('img', {
    staticStyle: {
      "width": "250px",
      "height": "100px",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.deal.from_signature
    }
  })]) : _c('div', {
    staticClass: "sign"
  }, [(_vm.freight && _vm.freight.from_signature) ? _c('img', {
    staticStyle: {
      "width": "250px",
      "height": "100px",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.freight.from_signature
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Данные для отслеживания груза")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("№ груза для отслеживания:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v(_vm._s(_vm.freight.traking_number))])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "qr"
  }, [_c('canvas', {
    ref: "qr"
  })])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.flagmanamur.ru/client/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Прочие данные приема")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_vm._v("Кладовщик:")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("Иванов И.И.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b55247ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/print/FreightPrintStockNote.vue
// module id = 1244
// module chunks = 0